<template>
  <SettingComponentPage title="ログイン方法" summary="利用者がどの方法でログインできるかを決めます。">
    <AuthPolicySettings/>
  </SettingComponentPage>
</template>

<script>
import SettingComponentPage from './SettingComponentPage.vue'
import AuthPolicySettings from '../AuthPolicySettings.vue'

export default {
  name: 'LoginPolicyEdit',
  components: { SettingComponentPage, AuthPolicySettings }
}
</script>
